import { Grid } from '@mui/material'
import NumberFormats from 'components/NumberFormats'
import Table from 'components/Table'
import useIsMobileView from 'hooks/useIsMobileView'
import React, { useMemo } from 'react'
import SpotMobileBox from './SpotMobileBox'

const headers = [
  {
    key: "coin",
    name: "Coin",
    align: "center",
  },
  {
    key: "locked",
    name: "Locked",
    align: "center",
  },
  {
    key: "availableBalance",
    name: "Available Balance",
    align: "center",
  },
  {
    key: "totalBalance",
    name: "Total Balance",
    align: "center",
  },
]

function SpotTable({ brokerInfoDetail }) {
  const isMobileView = useIsMobileView()

  const formattedItems = useMemo(() => brokerInfoDetail?.listSpot?.map((item) => ({
    ...item,
    availableBalance: <NumberFormats value={item?.availableBalance || 0} />,
    totalBalance: <NumberFormats value={item?.totalBalance || 0} />
  })), [brokerInfoDetail])

  return (
    <>
      {
        isMobileView ?
          <Grid container spacing={1}>
            {brokerInfoDetail?.listSpot?.map((item) => (
              <Grid item xs={12} sm={6}>
                <SpotMobileBox
                  item={item}
                />
              </Grid>
            ))}
          </Grid>
          :
          <Table
            headers={headers}
            items={formattedItems}
          />
      }
    </>
  )
}

export default SpotTable